
import { EventSource } from "eventsource";
import EventEmitter from "events";
import { ACCESS_TOKEN_HEADER_NAME } from '@xavisoft/auth/constants';
import { getAccessToken } from '@xavisoft/auth/frontend/utils';

class PushNotifications extends EventEmitter {

   /** @type {EventSource} */
   _es = null;
   _connected = false;

   /** @type {AudioContext} */
   _audioContext = null;

   createAudioContext() {
      if (this._audioContext)
         return;

      const AudioContext = window.AudioContext || window.webkitAudioContext;
      this._audioContext = new AudioContext();
   }

   beep() {
      
      const audioContext = this._audioContext;
      if (!audioContext)
         return;
      
      // Create an oscillator node
      const oscillator = audioContext.createOscillator();

      // Set oscillator properties
      oscillator.type = 'sine'; // Type of wave: sine, square, sawtooth, triangle
      oscillator.frequency.setValueAtTime(440, audioContext.currentTime); // Frequency in Hz (440 Hz = standard A note)

      // Create a gain node (volume control)
      const gainNode = audioContext.createGain();

      // Connect the oscillator to the gain node
      oscillator.connect(gainNode);

      // Connect the gain node to the audio context's destination (output)
      gainNode.connect(audioContext.destination);

      // Gradually decrease the volume to make the beep fade out
      gainNode.gain.setValueAtTime(1, audioContext.currentTime); // Start at full volume
      gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.5); // Fade out in 0.5 seconds

      // Start the oscillator
      oscillator.start();

      // Stop the oscillator after 0.5 seconds
      oscillator.stop(audioContext.currentTime + 0.5);

   }

   subscribe() {
      if (this._es)
         return;

      const accessToken = getAccessToken();

      const es = new EventSource("/api/general/notifications/sse", {
         fetch(url, opts) {
            return fetch(url, {
               ...opts,
               headers: {
                  ...opts.headers,
                  [ACCESS_TOKEN_HEADER_NAME]: accessToken,
               }
            })
         }
      });

      es.onmessage = (event) => {
         const data = JSON.parse(event.data);
         this.emit("notifications", data.notifications);
      };

      es.onerror = e => {
         this._connected = false;
         console.error("sse disconnected: ", e);
      };

      es.onopen = () => {
         console.log("sse connected");
         this._connected = true;
      };

      this._es = es;

   }

   unsubscribe() {
      if (this._es) {
         this._es.close();
         this._es = null;
      }
   }
}

// call push_notifications.createAudioContext() when the window receives a user gesture
window.addEventListener("click", () => push_notifications.createAudioContext());

const push_notifications = new PushNotifications();

export default push_notifications;